export default {
  date: 'DD.MM.YYYY',
  time: 'HH:mm:ss',
  datetimeShort: 'DD.MM.YYYY HH:mm',
  datetime: 'DD.MM.YYYY HH:mm:ss',
  dayOfWeek: 'dddd',
  crmDate: 'MM/DD/YYYY HH:mm:ss',
  crmDateShort: 'MM/DD/YYYY',
  noTZCommon: 'YYYY-MM-DD HH:mm:ss',
  supportChatMsg: 'DD.MMM.YYYY HH:mm',
  timeMS: 'HH:mm:ss:SSS',
} as const;

export enum periodTypes {
  Today = 'today',
  TodayFullDay = 'todayFullDay',
  Yesterday = 'yesterday',
  LastWeek = 'week',
  LastMonth = 'month',
  LastQuarter = '3months',
  LastYear = 'year',
}

export enum groupPeriodBy {
  Hour = '1h',
  Day = '1d',
  Week = '1w',
  Month = '1m',
  Quarter = '3m',
}

export const TIME_UNITS = {
  HOURS_PER_DAY: 24,
  DAYS_PER_WEEK: 7,
  APPROX_DAYS_PER_MONTH: 30,
  DAYS_PER_YEAR: 365,
} as const;
